import type { CaptureFormValues } from './types';

export const DEFAULT_FORM_VALUES: CaptureFormValues = {
  returnFullDocumentImage:          false,
  returnFaceImage:                  false,
  returnSignatureImage:             false,
  treatExpirationAsFraud:           false,
  screenMatchLevel:                 'Level5',
  photocopyMatchLevel:              'Level5',
  barcodeAnomalyMatchLevel:         'Level5',
  photoForgeryMatchLevel:           'Level5',
  staticSecurityFeaturesMatchLevel: 'Disabled',
  dataMatchMatchLevel:              'Level5',
  blurMatchLevel:                   'Level5',
  glareMatchLevel:                  'Level5',
  lightingMatchLevel:               'Level5',
  sharpnessMatchLevel:              'Level5',
  handOcclusionMatchLevel:          'Level5',
  dpiMatchLevel:                    'Level5',
  tiltMatchLevel:                   'Level5',
  imageQualityInterpretation:       'Conservative',
  returnImageFormat:                'Jpg',
  anonymizationMode:                'FullResult',
};

export const ADVANCED_OPTIONS = [
  'false','Disabled','Conservative','Jpg','FullResult',
  'Level1','Level2','Level3','Level4','Level5',
  'Level6','Level7','Level8','Level9','Level10','true',
] as const;

export const ID_OPTIONS                = ['INE', 'PASSPORT', 'FMM'] as const;
export const SAMPLE_TYPE_OPTIONS       = ['IMPRESION COLOR', 'IMPRESION B/N', 'SCREEN', 'REAL'] as const;
export const EXPECTED_RESPONSE_OPTIONS = ['Unknown', 'NotPerformed', 'Pass', 'Fail'] as const;

